/*! © 2026 Corone Laureae. Configurator implementation and visual assets: all rights reserved. */
(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-clside-root]';
  const SAFE_COLOR = /^#[0-9a-f]{6}$/i;

  const FAR_ANCHORS = [
    { x: 16, y: 58, scale: 0.66, rotate: -20 },
    { x: 28, y: 53, scale: 0.72, rotate: -13 },
    { x: 40, y: 50, scale: 0.78, rotate: -6 },
    { x: 50, y: 49, scale: 0.80, rotate: 0 },
    { x: 60, y: 50, scale: 0.78, rotate: 6 },
    { x: 72, y: 53, scale: 0.72, rotate: 13 },
    { x: 84, y: 58, scale: 0.66, rotate: 20 },
  ];

  const MID_ANCHORS = [
    { x: 9, y: 61, scale: 0.76, rotate: -25 },
    { x: 20, y: 62, scale: 0.84, rotate: -18 },
    { x: 32, y: 63, scale: 0.90, rotate: -10 },
    { x: 44, y: 64, scale: 0.94, rotate: -3 },
    { x: 56, y: 64, scale: 0.94, rotate: 3 },
    { x: 68, y: 63, scale: 0.90, rotate: 10 },
    { x: 80, y: 62, scale: 0.84, rotate: 18 },
    { x: 91, y: 61, scale: 0.76, rotate: 25 },
  ];

  const NEAR_ANCHORS = [
    { x: 12, y: 66, scale: 0.88, rotate: -20 },
    { x: 23, y: 71, scale: 0.96, rotate: -14 },
    { x: 36, y: 75, scale: 1.04, rotate: -7 },
    { x: 50, y: 77, scale: 1.10, rotate: 0 },
    { x: 64, y: 75, scale: 1.04, rotate: 7 },
    { x: 77, y: 71, scale: 0.96, rotate: 14 },
    { x: 88, y: 66, scale: 0.88, rotate: 20 },
  ];

  const CLUSTER_ANCHORS = [
    { x: 48, y: 67, scale: 0.94, rotate: -15, depth: 'mid', volume: 0.58 },
    { x: 64, y: 65, scale: 0.96, rotate: -5, depth: 'mid', volume: 0.60 },
    { x: 80, y: 67, scale: 0.94, rotate: 10, depth: 'mid', volume: 0.58 },
    { x: 91, y: 64, scale: 0.92, rotate: 20, depth: 'mid', volume: 0.54 },
    { x: 44, y: 83, scale: 0.94, rotate: -15, depth: 'near', volume: 0.66 },
    { x: 54, y: 87, scale: 0.97, rotate: -9, depth: 'near', volume: 0.72 },
    { x: 64, y: 82, scale: 0.95, rotate: -2, depth: 'near', volume: 0.68 },
    { x: 74, y: 87, scale: 0.98, rotate: 6, depth: 'near', volume: 0.74 },
    { x: 84, y: 82, scale: 0.95, rotate: 14, depth: 'near', volume: 0.68 },
    { x: 93, y: 85, scale: 0.92, rotate: 22, depth: 'near', volume: 0.64 },
  ];

  const BABY_SPARSE_VISIBLE_ANCHORS = [
    { x: 44, y: 64, scale: 0.92, rotate: -19, depth: 'mid', volume: 0.54 },
    { x: 51, y: 60, scale: 0.94, rotate: -15, depth: 'mid', volume: 0.58 },
    { x: 59, y: 67, scale: 0.96, rotate: -10, depth: 'mid', volume: 0.62 },
    { x: 67, y: 62, scale: 0.95, rotate: -3, depth: 'mid', volume: 0.60 },
    { x: 75, y: 66, scale: 0.94, rotate: 5, depth: 'mid', volume: 0.58 },
    { x: 83, y: 61, scale: 0.93, rotate: 12, depth: 'mid', volume: 0.56 },
    { x: 90, y: 66, scale: 0.92, rotate: 19, depth: 'mid', volume: 0.54 },
    { x: 96, y: 70, scale: 0.90, rotate: 24, depth: 'mid', volume: 0.52 },
    { x: 46, y: 78, scale: 0.94, rotate: -14, depth: 'near', volume: 0.64 },
    { x: 53, y: 84, scale: 0.97, rotate: -9, depth: 'near', volume: 0.70 },
    { x: 61, y: 79, scale: 0.95, rotate: -3, depth: 'near', volume: 0.66 },
    { x: 69, y: 85, scale: 0.98, rotate: 4, depth: 'near', volume: 0.72 },
    { x: 77, y: 79, scale: 0.95, rotate: 10, depth: 'near', volume: 0.66 },
    { x: 85, y: 84, scale: 0.96, rotate: 16, depth: 'near', volume: 0.68 },
    { x: 92, y: 78, scale: 0.93, rotate: 21, depth: 'near', volume: 0.62 },
    { x: 96, y: 83, scale: 0.90, rotate: 25, depth: 'near', volume: 0.58 },
  ];

  const SPARSE_12_ANCHORS = [
    { x: 10, y: 54, scale: 0.94, rotate: -24, depth: 'mid', volume: 0.58 },
    { x: 27, y: 52, scale: 0.96, rotate: -18, depth: 'mid', volume: 0.62 },
    { x: 42, y: 59, scale: 1.00, rotate: -11, depth: 'mid', volume: 0.68 },
    { x: 57, y: 54, scale: 1.00, rotate: -3, depth: 'mid', volume: 0.70 },
    { x: 73, y: 58, scale: 0.98, rotate: 9, depth: 'mid', volume: 0.66 },
    { x: 89, y: 63, scale: 0.94, rotate: 21, depth: 'mid', volume: 0.60 },
    { x: 37, y: 75, scale: 1.00, rotate: -10, depth: 'near', volume: 0.74 },
    { x: 47, y: 83, scale: 1.04, rotate: -5, depth: 'near', volume: 0.82 },
    { x: 59, y: 77, scale: 1.02, rotate: 2, depth: 'near', volume: 0.78 },
    { x: 70, y: 84, scale: 1.04, rotate: 8, depth: 'near', volume: 0.82 },
    { x: 82, y: 75, scale: 1.00, rotate: 16, depth: 'near', volume: 0.74 },
    { x: 94, y: 79, scale: 0.96, rotate: 24, depth: 'near', volume: 0.68 },
  ];

  const WOVEN_12_ANCHORS = [
    { x: 9, y: 57, scale: 0.94, rotate: -24, depth: 'mid', volume: 0.58 },
    { x: 24, y: 50, scale: 0.96, rotate: -19, depth: 'mid', volume: 0.62 },
    { x: 39, y: 61, scale: 1.00, rotate: -12, depth: 'mid', volume: 0.68 },
    { x: 54, y: 53, scale: 1.00, rotate: -3, depth: 'mid', volume: 0.70 },
    { x: 70, y: 60, scale: 0.98, rotate: 8, depth: 'mid', volume: 0.66 },
    { x: 88, y: 64, scale: 0.94, rotate: 20, depth: 'mid', volume: 0.60 },
    { x: 38, y: 79, scale: 1.02, rotate: -10, depth: 'near', volume: 0.78 },
    { x: 49, y: 73, scale: 1.00, rotate: -4, depth: 'near', volume: 0.74 },
    { x: 60, y: 84, scale: 1.04, rotate: 3, depth: 'near', volume: 0.82 },
    { x: 72, y: 77, scale: 1.02, rotate: 10, depth: 'near', volume: 0.78 },
    { x: 84, y: 83, scale: 1.02, rotate: 18, depth: 'near', volume: 0.78 },
    { x: 95, y: 75, scale: 0.96, rotate: 25, depth: 'near', volume: 0.68 },
  ];

  const GENERIC_10_ANCHORS = [
    { x: 11, y: 53, scale: 0.94, rotate: -24, depth: 'mid', volume: 0.58 },
    { x: 29, y: 51, scale: 0.96, rotate: -17, depth: 'mid', volume: 0.62 },
    { x: 46, y: 59, scale: 1.00, rotate: -9, depth: 'mid', volume: 0.68 },
    { x: 63, y: 54, scale: 1.00, rotate: 1, depth: 'mid', volume: 0.68 },
    { x: 82, y: 61, scale: 0.96, rotate: 16, depth: 'mid', volume: 0.62 },
    { x: 38, y: 76, scale: 1.00, rotate: -10, depth: 'near', volume: 0.74 },
    { x: 50, y: 83, scale: 1.03, rotate: -3, depth: 'near', volume: 0.82 },
    { x: 64, y: 76, scale: 1.01, rotate: 5, depth: 'near', volume: 0.76 },
    { x: 79, y: 84, scale: 1.02, rotate: 15, depth: 'near', volume: 0.80 },
    { x: 94, y: 75, scale: 0.96, rotate: 24, depth: 'near', volume: 0.68 },
  ];

  const GENERIC_10_ALT_ANCHORS = [
    { x: 9, y: 56, scale: 0.94, rotate: -24, depth: 'mid', volume: 0.58 },
    { x: 25, y: 50, scale: 0.96, rotate: -18, depth: 'mid', volume: 0.62 },
    { x: 42, y: 60, scale: 1.00, rotate: -10, depth: 'mid', volume: 0.68 },
    { x: 59, y: 53, scale: 1.00, rotate: 0, depth: 'mid', volume: 0.68 },
    { x: 77, y: 61, scale: 0.96, rotate: 14, depth: 'mid', volume: 0.62 },
    { x: 37, y: 80, scale: 1.01, rotate: -11, depth: 'near', volume: 0.78 },
    { x: 50, y: 74, scale: 1.00, rotate: -3, depth: 'near', volume: 0.74 },
    { x: 65, y: 84, scale: 1.03, rotate: 6, depth: 'near', volume: 0.82 },
    { x: 80, y: 76, scale: 1.00, rotate: 15, depth: 'near', volume: 0.74 },
    { x: 94, y: 82, scale: 0.96, rotate: 24, depth: 'near', volume: 0.70 },
  ];

  // Gli asset botanici v2 sono rametti completi e direzionali. Il volume non
  // nasce più da decine di ritagli ripetuti, ma da poche masse ariose con la
  // stessa scala fisica della corona fotografata.
  const PROFILES = {
    roses: { count: 3, width: 11.2, offsetX: 0, offsetY: 0, className: 'rose', farY: 0.96, midY: 0.98, nearY: 1, edgeX: 0.02, skew: 1.2 },
    'baby-breath': { count: 7, width: 18, clusterWidth: 19, sparseWidth: 16.5, offsetX: 0, offsetY: -.6, className: 'baby-breath', farY: 0.98, midY: 1, nearY: 1.02, edgeX: 0.02, skew: 1 },
    'fresh-baby-breath': { count: 7, width: 21, clusterWidth: 22, sparseWidth: 19, offsetX: 0, offsetY: -.6, className: 'fresh-baby-breath', farY: 0.98, midY: 1, nearY: 1.02, edgeX: 0.02, skew: 1 },
    berries: { count: 10, width: 7.8, offsetX: 0, offsetY: -.8, className: 'berries', farY: 0.98, midY: 1, nearY: 1.02, edgeX: 0.02, skew: .8 },
    hypericum: { count: 10, width: 4.5, offsetX: 0, offsetY: -.8, className: 'hypericum', farY: 0.98, midY: 1, nearY: 1.02, edgeX: 0.02, skew: .8 },
    gardenia: { count: 2, width: 30.3, offsetX: 0, offsetY: -.5, className: 'gardenia', farY: 0.97, midY: .99, nearY: 1, edgeX: 0.02, skew: 1 },
    sunflower: { count: 2, width: 24, offsetX: 0, offsetY: 0, className: 'sunflower', farY: 1, midY: 1, nearY: 1, edgeX: 0, skew: 0 },
    hydrangea: { count: 7, width: 21.9, offsetX: 0, offsetY: -1, className: 'hydrangea', farY: 0.96, midY: 1, nearY: 1.03, edgeX: 0.02, skew: 1 },
    lagurus: { count: 10, width: 9.4, offsetX: 0, offsetY: -.4, className: 'lagurus', farY: 0.98, midY: 1, nearY: 1.02, edgeX: 0.02, skew: .35 },
  };

  const SIDE_FLOWER_LAYOUTS = {
    2: [
      { x: 58, y: 78, scale: 0.96, rotate: -5, depth: 'near', volume: 0.18 },
      { x: 86, y: 78, scale: 0.96, rotate: 8, depth: 'near', volume: 0.18 },
    ],
    3: [
      { x: 50, y: 78, scale: 0.95, rotate: -7, depth: 'near', volume: 0.16 },
      { x: 70, y: 78, scale: 1, rotate: 1, depth: 'near', volume: 0.16 },
      { x: 90, y: 78, lift: -1.1, scale: 0.95, rotate: 9, depth: 'near', volume: 0.16 },
    ],
    4: [
      { x: 47, y: 78, scale: 0.94, rotate: -8, depth: 'near', volume: 0.15 },
      { x: 62, y: 78, scale: 0.98, rotate: -3, depth: 'near', volume: 0.15 },
      { x: 77, y: 78, scale: 0.98, rotate: 4, depth: 'near', volume: 0.15 },
      { x: 90.5, y: 78, lift: -1.8, scale: 0.94, rotate: 10, depth: 'near', volume: 0.15 },
    ],
  };

  const SMALL_ROSE_SCALE = 0.72;
  const SIDE_SMALL_ROSE_LAYOUTS = {
    3: [
      { x: 49, y: 78, lift: -2.5, scale: .95, rotate: -7, depth: 'near', level: 'upper', volume: .16 },
      { x: 69, y: 78, lift: 1, scale: 1, rotate: 1, depth: 'near', level: 'center', volume: .16 },
      { x: 87, y: 78, lift: 4.4, scale: .95, rotate: 9, depth: 'near', level: 'lower', volume: .16 },
    ],
    4: [
      { x: 45, y: 78, lift: -2.5, scale: .94, rotate: -8, depth: 'near', level: 'upper', volume: .15 },
      { x: 60, y: 78, lift: 4.4, scale: .98, rotate: -3, depth: 'near', level: 'lower', volume: .15 },
      { x: 76, y: 78, lift: 1, scale: .98, rotate: 4, depth: 'near', level: 'center', volume: .15 },
      { x: 90, y: 78, lift: -2.5, scale: .94, rotate: 10, depth: 'near', level: 'upper', volume: .15 },
    ],
    5: [
      { x: 44, y: 78, lift: 1, scale: .94, rotate: -8, depth: 'near', level: 'center', volume: .15 },
      { x: 56, y: 78, lift: -2.5, scale: .98, rotate: -4, depth: 'near', level: 'upper', volume: .15 },
      { x: 68, y: 78, lift: 4.4, scale: 1, rotate: 1, depth: 'near', level: 'lower', volume: .15 },
      { x: 80, y: 78, lift: 1, scale: .98, rotate: 5, depth: 'near', level: 'center', volume: .15 },
      { x: 91, y: 78, lift: -2.5, scale: .94, rotate: 10, depth: 'near', level: 'upper', volume: .15 },
    ],
  };

  // Le gardenie sono più aperte delle rose e vengono inserite negli intervalli
  // liberi della composizione, non sulle stesse coordinate dei boccioli.
  const SIDE_GARDENIA_LAYOUT = [
    { x: 54, y: 69, scale: 0.9, rotate: -8, depth: 'mid', volume: 0.24 },
    { x: 84, y: 69, scale: 0.9, rotate: 10, depth: 'mid', volume: 0.24 },
  ];

  const NEW_ROSE_FILTERS = {
    azzurro: 'hue-rotate(183deg) saturate(.6) brightness(1.8)',
    'rosa-scuro': 'hue-rotate(342deg) saturate(.88) brightness(1.15)',
    fucsia: 'hue-rotate(314deg) saturate(1.05) brightness(1.35)',
    turchese: 'hue-rotate(168deg) saturate(.84) brightness(1.25)',
    bordeaux: 'saturate(.82) brightness(.66)',
    'viola-scuro': 'hue-rotate(264deg) saturate(.76) brightness(.69)',
    bourdeaux: 'saturate(.82) brightness(.55)',
    'rosa-confetto': 'saturate(.35) brightness(2.1)',
    lilla: 'hue-rotate(285deg) saturate(.3) brightness(1.7)',
    'blu-elettrico': 'hue-rotate(218deg) saturate(1.8) brightness(1.15)',
    gialle: 'hue-rotate(55deg) saturate(1.6) brightness(2)',
    nere: 'grayscale(1) brightness(.18)',
  };

  const SIDE_BABY_CLUSTER_LAYOUT = [
    { x: 40, y: 71, scale: .86, rotate: -13, depth: 'mid', volume: .27 },
    { x: 51, y: 81, scale: .9, rotate: -8, depth: 'near', volume: .31 },
    { x: 61, y: 61, scale: .82, rotate: -4, depth: 'far', volume: .24 },
    { x: 70, y: 71, scale: .88, rotate: 2, depth: 'mid', volume: .27 },
    { x: 79, y: 82, scale: .9, rotate: 8, depth: 'near', volume: .31 },
    { x: 87, y: 69, scale: .84, rotate: 14, depth: 'mid', volume: .26 },
    { x: 92, y: 60, scale: .78, rotate: 21, depth: 'far', volume: .23 },
  ];

  const SIDE_BABY_SPARSE_LAYOUT = [
    { x: 40, y: 71, scale: .78, rotate: -15, depth: 'mid', volume: .23 },
    { x: 46, y: 61, scale: .75, rotate: -12, depth: 'far', volume: .21 },
    { x: 48, y: 82, scale: .82, rotate: -10, depth: 'near', volume: .27 },
    { x: 54, y: 72, scale: .8, rotate: -8, depth: 'mid', volume: .24 },
    { x: 61, y: 59, scale: .77, rotate: -4, depth: 'far', volume: .22 },
    { x: 66, y: 84, scale: .84, rotate: 0, depth: 'near', volume: .29 },
    { x: 69, y: 70, scale: .8, rotate: 4, depth: 'mid', volume: .24 },
    { x: 76, y: 61, scale: .76, rotate: 8, depth: 'far', volume: .21 },
    { x: 81, y: 72, scale: .8, rotate: 12, depth: 'mid', volume: .24 },
    { x: 84, y: 81, scale: .82, rotate: 16, depth: 'near', volume: .27 },
    { x: 89, y: 68, scale: .77, rotate: 19, depth: 'mid', volume: .22 },
    { x: 92, y: 59, scale: .72, rotate: 23, depth: 'far', volume: .2 },
  ];

  // Final, transformed image centres on the photographed FRONT half. These
  // do not feed makePiece's seed/volume/scale calculations. The lower recalls
  // sit on the broad leaf faces, not on the table or the rear rim.
  const BABY_FRONT_CENTRES = {
    clusters: [
      [42, 79, 'center'], [52, 88.5, 'lower'], [60, 74.5, 'upper'],
      [70, 79, 'center'], [77.5, 85, 'lower'], [85, 72, 'center'],
      [87, 63.5, 'upper'],
    ],
    sparse: [
      [42, 78.5, 'center'], [48.5, 73.5, 'upper'], [46.5, 86.5, 'lower'],
      [54, 81, 'center'], [60, 74.5, 'upper'], [63, 89, 'lower'],
      [70, 79, 'center'], [76, 70, 'upper'], [80, 75.5, 'center'],
      [78, 84.5, 'lower'], [88, 70.5, 'center'], [87, 63.5, 'upper'],
    ],
  };

  function babyFrontCentres(sparse, heads) {
    const occupied = [];
    return BABY_FRONT_CENTRES[sparse ? 'sparse' : 'clusters'].map(([x, y, level]) => {
      // Five bounded alternatives on the SAME level. Light edge overlaps are
      // natural; the penalty concerns crowded centres, not transparent boxes.
      const candidates = [[0, 0], [-1.8, -.5], [1.8, .5], [-.8, .8], [.8, -.8]];
      const scored = candidates.map(([dx, dy]) => {
        const point = { x: clamp(x + dx, 41.5, 89.5), y: y + dy, level };
        let score = (dx * dx + dy * dy) * .015;
        for (const head of heads) {
          const distance = Math.hypot((point.x - head.x) / head.rx, (point.y - head.y) / head.ry);
          score += Math.max(0, 1 - distance) ** 2 * 12;
        }
        for (const other of occupied) score += Math.max(0, 6 - Math.hypot(point.x - other.x, point.y - other.y)) ** 2;
        return { point, score };
      });
      scored.sort((a, b) => a.score - b.score);
      occupied.push(scored[0].point);
      return scored[0].point;
    });
  }

  function placeFrontCorrections(scene, entries) {
    if (!scene.isConnected) return;
    const bounds = scene.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return;
    entries.forEach(entry => {
      let target;
      if (/^(?:lagurus|berries|hypericum)$/.test(entry.kind)) {
        target = { 0: { y: 72.3 }, 2: { x: 87, y: 62.5 }, 6: { x: 90, y: 66.5 } }[entry.index];
      }
      if (entry.kind === 'hydrangea') {
        target = { 1: { x: 46, y: 80.5 }, 3: { x: 59, y: 76.2 }, 6: { x: 85.8 } }[entry.index];
      }
      if (!target || entry.piece.isConnected === false) return;
      if (entry.piece.tagName === 'IMG' && (!entry.piece.complete || !entry.piece.naturalWidth)) return;
      const rect = entry.piece.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const style = entry.piece.style;
      if (typeof target.x === 'number') {
        const x = (rect.left + rect.width / 2 - bounds.left) / bounds.width * 100;
        style.setProperty('--clside-x', `${parseFloat(style.getPropertyValue('--clside-x')) + target.x - x}%`);
      }
      if (typeof target.y === 'number') {
        const y = (rect.top + rect.height / 2 - bounds.top) / bounds.height * 100;
        style.setProperty('--clside-y', `${parseFloat(style.getPropertyValue('--clside-y')) + target.y - y}%`);
      }
    });
  }

  function separateBabyFrontCentre(target, kind) {
    const pairCenterX = clamp(target.x, 43.9, 87.1);
    const x = pairCenterX + (kind === 'fresh-baby-breath' ? 2.4 : -2.4);
    const y = target.y + clamp(visibleFrontArcY(x) - visibleFrontArcY(target.x), -1.1, 1.1);
    return { ...target, x, y };
  }

  function placeLagurusRoseClearance(scene, entries) {
    if (!scene.isConnected) return;
    const bounds = scene.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return;
    const roseCount = entries.filter(entry => entry.kind === 'roses').length;
    const hasSmallRoses = entries.some(entry => entry.kind === 'roses' && roseSize(entry.item) === 'piccola');
    const plans = hasSmallRoses ? {
      3: { 3: [43, 83], 5: [80, 71], 9: [88, 78] },
      4: { 3: [45, 84], 7: [66, 88], 8: [78, 83] },
      5: { 3: [48, 85], 4: [61, 79], 6: [89, 69], 7: [64, 88], 8: [77, 84] },
    } : {
      2: { 4: [53.8, 81.4], 5: [78.5, 73], 7: [65.5, 87] },
      3: { 6: [84.5, 66.5] },
      4: { 4: [55, 81.5], 6: [84.5, 66.5], 7: [66, 86.5] },
    };
    entries.forEach(entry => {
      if (entry.kind !== 'lagurus' || entry.piece.isConnected === false) return;
      const style = entry.piece.style;
      const target = plans[roseCount]?.[entry.index];
      if (entry.roseClearanceOrigin) {
        style.setProperty('--clside-x', entry.roseClearanceOrigin.x);
        style.setProperty('--clside-y', entry.roseClearanceOrigin.y);
        if (!target) delete entry.roseClearanceOrigin;
      }
      if (!target) return;
      const rect = entry.piece.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      if (!entry.roseClearanceOrigin) entry.roseClearanceOrigin = {
        x: style.getPropertyValue('--clside-x'), y: style.getPropertyValue('--clside-y'),
      };
      const x = (rect.left + rect.width / 2 - bounds.left) / bounds.width * 100;
      const y = (rect.top + rect.height / 2 - bounds.top) / bounds.height * 100;
      style.setProperty('--clside-x', `${parseFloat(style.getPropertyValue('--clside-x')) + target[0] - x}%`);
      style.setProperty('--clside-y', `${parseFloat(style.getPropertyValue('--clside-y')) + target[1] - y}%`);
    });
  }

  function normalizedGardeniaBounds(piece, bounds) {
    if (piece.dataset.clsideGardeniaNormalized !== 'white-v1'
      || piece.hidden || !piece.complete || !piece.naturalWidth) return null;
    const read = name => parseFloat(piece.style.getPropertyValue(`--clside-${name}`));
    const w = bounds.width * read('width') / 100;
    const h = w * 480 / 720;
    const rotation = read('rotate') * Math.PI / 180;
    const skew = Math.tan(read('skew') * Math.PI / 180);
    const sx = read('scale') * read('scale-x'), sy = read('scale') * read('scale-y');
    const a = Math.cos(rotation) * sx, b = Math.sin(rotation) * sx;
    const c = (Math.cos(rotation) * skew - Math.sin(rotation)) * sy;
    const d = (Math.sin(rotation) * skew + Math.cos(rotation)) * sy;
    const x = (363 / 720 - .5) * w, y = (235 / 480 - .58) * h;
    const cx = bounds.left + read('x') / 100 * bounds.width + a * x + c * y;
    const cy = bounds.top + read('y') / 100 * bounds.height + .08 * h + b * x + d * y;
    const rx = .6 * w * (83 / 56) / 2, ry = (388 / 480) * h * (83 / 56) / 2;
    const ex = Math.abs(a) * rx + Math.abs(c) * ry;
    const ey = Math.abs(b) * rx + Math.abs(d) * ry;
    if (![cx, cy, ex, ey].every(Number.isFinite)) return null;
    return { left: cx - ex, top: cy - ey, width: ex * 2, height: ey * 2 };
  }

  const GARDENIA_SMALL_REVIEW = {"bianco":[[-1,3],[-1,0]],"rosa-antico":[[1,3],[-2,-3]]};
  function placeGardeniaSmallReview(scene, entries) {
    if (!scene.isConnected) return;
    entries.filter(entry => entry.kind === 'gardenia').forEach(entry => {
      const color = /^(?:bianco|bianca|bianco-optical)$/.test(entry.item.colorKey) ? 'bianco' : 'rosa-antico';
      const delta = GARDENIA_SMALL_REVIEW[color]?.[entry.index];
      if (!delta) return;
      const style = entry.piece.style;
      if (!entry.gardeniaSmallOrigin) entry.gardeniaSmallOrigin = [parseFloat(style.getPropertyValue('--clside-x')), parseFloat(style.getPropertyValue('--clside-y'))];
      style.setProperty('--clside-x', (entry.gardeniaSmallOrigin[0] + delta[0]) + '%');
      style.setProperty('--clside-y', (entry.gardeniaSmallOrigin[1] + delta[1]) + '%');
    });
  }

  function placeBabyFront(scene, entries) {
    placeGardeniaSmallReview(scene, entries);
    // These approved head corrections also run for single-family previews.
    // Nebbiolina, when present, then avoids their corrected visible centres.
    placeFrontCorrections(scene, entries);
    placeLagurusRoseClearance(scene, entries);
    const babies = entries.filter(entry => /^(?:fresh-)?baby-breath$/.test(entry.kind));
    if (!babies.length || !scene.isConnected) return;
    const bounds = scene.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return;
    const measured = entry => {
      const rect = normalizedGardeniaBounds(entry.piece, bounds) || entry.piece.getBoundingClientRect();
      return { x: (rect.left + rect.width / 2 - bounds.left) / bounds.width * 100,
        y: (rect.top + rect.height / 2 - bounds.top) / bounds.height * 100,
        width: rect.width / bounds.width * 100, height: rect.height / bounds.height * 100 };
    };
    const heads = entries.filter(entry => !/^(?:fresh-)?baby-breath$/.test(entry.kind))
      .map(entry => {
        const rect = measured(entry);
        const broadFlower = /roses|gardenia|hydrangea/.test(entry.kind);
        return { x: rect.x, y: rect.y, rx: Math.max(3.5, rect.width * (broadFlower ? .43 : .42)),
          ry: Math.max(2.4, rect.height * (broadFlower ? .40 : .40)) };
      }).sort((a, b) => a.x - b.x || a.y - b.y);
    const plans = new Map();
    const familiesByMode = new Map();
    babies.forEach(entry => {
      const sparse = String(entry.item.mode || '').toLowerCase() === 'sparsa';
      if (!familiesByMode.has(sparse)) familiesByMode.set(sparse, new Set());
      familiesByMode.get(sparse).add(entry.kind);
    });
    babies.forEach(entry => {
      const sparse = String(entry.item.mode || '').toLowerCase() === 'sparsa';
      if (!plans.has(sparse)) plans.set(sparse, babyFrontCentres(sparse, heads));
      const planned = plans.get(sparse)[entry.index];
      const target = planned && familiesByMode.get(sparse).size > 1
        ? separateBabyFrontCentre(planned, entry.kind)
        : planned;
      const rect = measured(entry);
      if (!target || !entry.piece.complete || !entry.piece.naturalWidth || !rect.height) return;
      // CSS mirroring about 14% 82% moves the visible centre far away from the
      // nominal anchor. Translate the actual rectangle instead of changing
      // transform-origin, asset orientation, width, scale, filter or depth.
      const style = entry.piece.style;
      style.setProperty('--clside-x', `${parseFloat(style.getPropertyValue('--clside-x')) + target.x - rect.x}%`);
      style.setProperty('--clside-y', `${parseFloat(style.getPropertyValue('--clside-y')) + target.y - rect.y}%`);
      entry.piece.dataset.clsideBabyLevel = target.level;
    });
  }

  const SIDE_HYDRANGEA_LAYOUT = [
    { x: 42, y: 59, scale: .88, rotate: 24, depth: 'mid', level: 'upper', volume: .22 },
    { x: 51, y: 72, scale: .91, rotate: 29, depth: 'mid', level: 'center', volume: .27 },
    { x: 61, y: 80, scale: .94, rotate: 34, depth: 'near', level: 'lower', volume: .31 },
    { x: 70, y: 59, scale: .89, rotate: 39, depth: 'mid', level: 'upper', volume: .22 },
    { x: 79, y: 71, scale: .92, rotate: 44, depth: 'mid', level: 'center', volume: .27 },
    { x: 87, y: 79, scale: .94, rotate: 49, depth: 'near', level: 'lower', volume: .30 },
    { x: 93, y: 57, scale: .86, rotate: 54, depth: 'mid', level: 'upper', volume: .20 },
  ];

  const SIDE_LAGURUS_LAYOUT = [
    { x: 41, y: 68, scale: .91, rotate: -7, depth: 'mid', level: 'upper', volume: .18 },
    { x: 67, y: 73, scale: .94, rotate: 1, depth: 'mid', level: 'upper', volume: .20 },
    { x: 91, y: 62, scale: .88, rotate: 4, depth: 'mid', level: 'upper', volume: .17 },
    { x: 45, y: 77, scale: .94, rotate: -5, depth: 'mid', level: 'center', volume: .22 },
    { x: 58, y: 81, scale: .99, rotate: 0, depth: 'mid', level: 'center', volume: .25 },
    { x: 83, y: 71, scale: .94, rotate: -2, depth: 'mid', level: 'center', volume: .21 },
    { x: 94, y: 65, scale: .87, rotate: 5, depth: 'mid', level: 'center', volume: .18 },
    { x: 62, y: 87, scale: 1, rotate: -1, depth: 'near', level: 'lower', volume: .28 },
    { x: 75, y: 82, scale: .98, rotate: 2, depth: 'near', level: 'lower', volume: .26 },
    { x: 87, y: 76, scale: .93, rotate: -3, depth: 'near', level: 'lower', volume: .22 },
  ];

  const HYDRANGEA_8_ANCHORS = [
    { x: 10, y: 55, scale: 0.94, rotate: -24, depth: 'mid', volume: 0.58 },
    { x: 31, y: 51, scale: 0.97, rotate: -16, depth: 'mid', volume: 0.64 },
    { x: 53, y: 59, scale: 1.00, rotate: -5, depth: 'mid', volume: 0.68 },
    { x: 76, y: 54, scale: 0.97, rotate: 10, depth: 'mid', volume: 0.64 },
    { x: 93, y: 63, scale: 0.94, rotate: 22, depth: 'mid', volume: 0.58 },
    { x: 41, y: 78, scale: 1.00, rotate: -8, depth: 'near', volume: 0.76 },
    { x: 64, y: 84, scale: 1.02, rotate: 5, depth: 'near', volume: 0.80 },
    { x: 87, y: 77, scale: 0.98, rotate: 18, depth: 'near', volume: 0.72 },
  ];

  const MATERIAL_Z = {
    'fresh-baby-breath': 0,
    berries: 2,
    hypericum: 3,
    'baby-breath': 4,
    hydrangea: 5,
    lagurus: 6,
    roses: 512,
    gardenia: 14,
  };

  // A side view needs its own vertical rhythm. These curves deliberately
  // alternate high, body and low positions inside each depth plane so dense
  // compositions read as a volume instead of a row laid over the wreath.
  const SIDE_VOLUME_CURVES = {
    far: [-4.6, 1.3, -2.8, 2.2, -3.6, 0.8, 3.0],
    mid: [2.9, -4.2, 1.4, -2.7, 3.7, -1.8, 2.3, -3.4],
    near: [-2.5, 4.4, -3.7, 2.5, 4.9, -1.5, 3.3, -4.0, 1.2],
  };

  const SIDE_VOLUME_PROFILES = {
    roses: { spread: 1.06, scale: 0.010, bias: { far: -0.8, mid: 0, near: 1.0 } },
    gardenia: { spread: 1.02, scale: 0.009, bias: { far: -0.7, mid: 0, near: 0.9 } },
    'baby-breath': { spread: 1.00, scale: 0.006, bias: { far: -0.6, mid: 0, near: 0.8 } },
    'fresh-baby-breath': { spread: 1.00, scale: 0.006, bias: { far: -0.6, mid: 0, near: 0.8 } },
    hydrangea: { spread: 0.86, scale: 0.007, bias: { far: -0.5, mid: 0, near: 0.7 } },
    lagurus: { spread: 1.18, scale: 0.006, bias: { far: -0.8, mid: -0.2, near: 0.8 } },
    berries: { spread: 1.00, scale: 0.007, bias: { far: -0.5, mid: 0, near: 0.8 } },
    hypericum: { spread: 0.94, scale: 0.007, bias: { far: -0.5, mid: 0, near: 0.7 } },
  };

  // Ogni ritaglio ha un ingombro diverso: il margine verso il foro interno
  // deve seguire il prodotto, non una tolleranza generica. I valori lasciano
  // una lieve immersione fra le foglie senza far apparire elementi sul lato
  // posteriore della corona.
  const MATERIAL_BACK_REACH = {
    gardenia: 5.0,
    hydrangea: 5.5,
    lagurus: 6.5,
    berries: 9.5,
    hypericum: 9.0,
  };

  const FILTERS = {
    bianco: 'saturate(.35) brightness(1.16)',
    bianca: 'saturate(.35) brightness(1.16)',
    'bianco-optical': 'saturate(.25) brightness(1.24)',
    'bianco-avorio': 'sepia(.12) saturate(.7) brightness(1.12)',
    avorio: 'sepia(.12) saturate(.7) brightness(1.12)',
    rosa: 'hue-rotate(315deg) saturate(.72) brightness(1.08)',
    'rosa-antico': 'hue-rotate(315deg) saturate(.55) brightness(.98)',
    viola: 'hue-rotate(245deg) saturate(1.05) brightness(.86)',
    lilla: 'hue-rotate(250deg) saturate(.62) brightness(1.08)',
    blu: 'hue-rotate(205deg) saturate(1.25) brightness(.78)',
    celeste: 'hue-rotate(175deg) saturate(.62) brightness(1.13)',
    giallo: 'hue-rotate(35deg) saturate(1.12) brightness(1.13)',
    gialla: 'hue-rotate(35deg) saturate(1.12) brightness(1.13)',
    oro: 'sepia(.72) hue-rotate(2deg) saturate(1.35) brightness(1.02)',
    fucsia: 'hue-rotate(300deg) saturate(1.3) brightness(.92)',
    cappuccino: 'sepia(.46) saturate(.68) brightness(.9)',
    salmone: 'hue-rotate(330deg) saturate(.72) brightness(1.1)',
    naturale: 'sepia(.22) saturate(.78) brightness(1.02)',
  };

  // Filtri ricavati dalle fotografie prodotto: ortensia e lagurus partono
  // da ritagli neutri diversi e non possono condividere una tinta generica.
  const MATERIAL_FILTERS = {
    gardenia: {
      bianco: 'saturate(.72) brightness(1.01) contrast(1.02)',
      bianca: 'saturate(.72) brightness(1.01) contrast(1.02)',
      'bianco-optical': 'saturate(.62) brightness(1.04) contrast(1.01)',
      'rosa-antico': 'saturate(1.14) brightness(.97) contrast(1.05)',
      rosa: 'saturate(1.2) brightness(.99) contrast(1.05)',
    },
    hydrangea: {
      bianca: 'grayscale(.12) sepia(.08) saturate(.62) brightness(1.08) contrast(.97)',
      cappuccino: 'grayscale(.06) sepia(.85) saturate(.74) hue-rotate(328deg) brightness(.68) contrast(1.1)',
      celeste: 'grayscale(.18) sepia(.48) saturate(2.7) hue-rotate(183deg) brightness(.92) contrast(1.01)',
      salmone: 'sepia(.62) saturate(1.72) hue-rotate(324deg) brightness(1.01) contrast(.99)',
      rosa: 'sepia(.54) saturate(2.25) hue-rotate(288deg) brightness(.95) contrast(1.02)',
      gialla: 'sepia(.92) saturate(3.35) hue-rotate(350deg) brightness(.91) contrast(1.05)',
    },
    lagurus: {
      bianco: 'sepia(.14) saturate(.68) brightness(1.01) contrast(.99)',
      giallo: 'sepia(1) saturate(6) hue-rotate(358deg) brightness(.68) contrast(1.15)',
      rosso: 'saturate(.92) brightness(.88) contrast(1.12)',
      naturale: 'sepia(.85) saturate(1.25) brightness(.64) contrast(1.1)',
      fucsia: 'sepia(1) saturate(16) hue-rotate(285deg) brightness(.72) contrast(1.2)',
    },
  };

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  // Il fiocco occupa soltanto una zona locale della fotografia. La protezione
  // segue separatamente il corpo del fiocco e le bande: non svuota più tutto
  // il lato sinistro della corona.
  function keepBowClear(x, y, index, halfWidth, halfHeight) {
    const bodyCollision = x + halfWidth > 3
      && x - halfWidth < 34.5
      && y + halfHeight > 50
      && y - halfHeight < 81;
    const tailsCollision = x + halfWidth > 8
      && x - halfWidth < 30.5
      && y + halfHeight > 62
      && y - halfHeight < 98;
    if (!bodyCollision && !tailsCollision) return { x, y };
    const protectedRight = bodyCollision ? 34.5 : 30.5;
    const laneOffset = (index % 3) * 3.2;
    return { x: protectedRight + halfWidth + 0.8 + laneOffset, y };
  }

  // Proiezione del solo semicerchio anteriore. Alle estremità la decorazione
  // sale sulle spalle della corona; il punto più profondo segue la prospettiva
  // fotografica ed è leggermente spostato a destra rispetto al centro.
  // L'arco superiore/posteriore non riceve mai prodotti.
  function visibleFrontArcY(x) {
    const frontDepth = clamp(1 - (Math.abs(x - 57) / 46), 0, 1);
    return 60.5 + (22 * (frontDepth ** 0.88));
  }

  function naturalMaterialRotation(kind, x, y, anchorRotation, phase) {
    if (kind === 'lagurus') {
      const arcPosition = clamp((x - 57) / 43, -.9, .9);
      const tangent = Math.atan2(-18 * arcPosition, 43 * Math.sqrt(1 - arcPosition * arcPosition)) * 180 / Math.PI;
      return clamp(tangent + anchorRotation * .25 + phase * .3, -40, 24);
    }
    const directional = /baby-breath|fresh-baby-breath|lagurus|hypericum|berries|hydrangea/.test(kind);
    return anchorRotation + phase * (directional ? .65 : 1.1);
  }

  function hashString(value) {
    let hash = 2166136261;
    for (let index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function safeUrl(value) {
    const url = String(value || '').trim();
    return /^(https?:)?\/\//i.test(url) || /^\//.test(url) ? url : '';
  }

  function sunflowerPixelSize(previewWidth) {
    const width = Number(previewWidth);
    return Number.isFinite(width) && width > 0 ? Math.round(width * 0.23 * 100) / 100 : 0;
  }

  // The same photographed head and pixel size serve both 2D views. This
  // controller is independent of the optional lateral panel and its parent
  // percentages; it never changes the selected products or the 3D state.
  function createSunflowerPhotoPreview(host) {
    const previewCard = host.querySelector('.clc__preview-card');
    const source = safeUrl(host.dataset.sunflowerPhotoUrl);
    const watched = new WeakSet();
    let disposed = false;
    let state = 'loading';
    let lastSize = -1;
    host.dataset.sunflowerPhotoState = state;

    const syncSize = () => {
      if (disposed) return;
      // clientWidth is independent of the selected/hidden panel and bow shape.
      const size = sunflowerPixelSize(previewCard?.clientWidth);
      if (size === lastSize) return;
      lastSize = size;
      host.style.setProperty('--cl-sunflower-size', `${size}px`);
    };
    const unavailable = () => {
      if (disposed || state === 'unavailable') return;
      state = 'unavailable';
      host.dataset.sunflowerPhotoState = state;
      // No generated flower, coloured fill, product mutation or automatic retry.
      console.warn('[Corone Laureae] Sunflower preview photograph unavailable. Product selection is unchanged.');
      host.dispatchEvent(new CustomEvent('clc:sunflower-photo-unavailable', {
        detail: { source, fallback: 'hidden-photo', selectionChanged: false },
      }));
    };
    const watch = (image) => {
      if (!image || watched.has(image)) return;
      watched.add(image);
      image.dataset.clcSunflowerPhoto = '';
      image.dataset.sunflowerPhotoState = 'loading';
      if (!source || state === 'unavailable') {
        image.hidden = true;
        unavailable();
        return;
      }
      const loaded = () => {
        if (disposed || state === 'unavailable') return;
        if (!image.naturalWidth) { unavailable(); return; }
        image.dataset.sunflowerPhotoState = 'ready';
        state = 'ready';
        host.dataset.sunflowerPhotoState = state;
      };
      image.addEventListener('load', loaded, { once: true });
      image.addEventListener('error', unavailable, { once: true });
      if (image.getAttribute('src') !== source) image.src = source;
      if (image.complete) loaded();
    };
    host.querySelectorAll('[data-clc-sunflower-photo]').forEach(watch);
    syncSize();
    const observer = typeof ResizeObserver === 'function' && previewCard ? new ResizeObserver(syncSize) : null;
    observer?.observe(previewCard);
    window.addEventListener('resize', syncSize, { passive: true });
    return {
      source, watch, syncSize,
      destroy() {
        disposed = true;
        observer?.disconnect();
        window.removeEventListener('resize', syncSize);
        delete host.clSunflowerPhotoPreview;
      },
    };
  }

  function parseAssets(root) {
    try {
      const parsed = JSON.parse(root.dataset.clsideAssets || '{}');
      return Object.fromEntries(Object.entries(parsed).map(([key, value]) => [key, safeUrl(value)]));
    } catch (_error) {
      return {};
    }
  }

  function normalizeKind(item) {
    return String(item?.type || item?.id || '').trim().toLowerCase();
  }

  function itemList(state) {
    return [...(Array.isArray(state?.stabilized) ? state.stabilized : []), ...(Array.isArray(state?.fresh) ? state.fresh : [])];
  }

  function textureFor(kind, item, assets) {
    const dynamic = safeUrl(item?.imageUrl);
    const colorKey = String(item?.colorKey || '').toLowerCase();
    if (kind === 'roses' && dynamic && colorKey !== 'rosso') return dynamic;
    if (kind === 'baby-breath' && dynamic) return dynamic;
    if (kind === 'baby-breath' && colorKey === 'rosa') return assets.babyBreathPink || assets.babyBreath;
    if (kind === 'baby-breath' && colorKey === 'viola') return assets.babyBreathPurple || assets.babyBreath;
    if (kind === 'baby-breath' && colorKey === 'rosso') return assets.babyBreathRed || assets.babyBreath;
    if (kind === 'berries') return String(item?.colorKey || '').includes('oro') ? assets.berryGold : assets.berryRed;
    if (kind === 'gardenia') {
      const isWhite = colorKey === 'bianco' || colorKey === 'bianca' || colorKey === 'bianco-optical';
      return isWhite ? (assets.gardeniaWhite || assets.gardenia) : (assets.gardenia || assets.gardeniaWhite);
    }
    if (kind === 'hypericum' && colorKey === 'bianco-avorio') {
      return assets.hypericumIvory || assets.hypericum;
    }
    if (kind === 'lagurus') return assets.lagurusSideHead || assets.lagurus || assets.lagurusNatural;
    const map = {
      roses: 'rose',
      'baby-breath': 'babyBreath',
      'fresh-baby-breath': 'freshBabyBreath',
      hypericum: 'hypericum',
      gardenia: 'gardenia',
      hydrangea: 'hydrangea',
      lagurus: 'lagurus',
    };
    return assets[map[kind]] || '';
  }

  function profileCount(kind, item) {
    if (kind === 'sunflower') return Math.ceil(clamp(Number.parseInt(item?.quantity || '1', 10) || 1, 1, 3) / 2);
    if (kind === 'roses') {
      const small = roseSize(item) === 'piccola';
      const total = clamp(Number.parseInt(item?.quantity || (small ? '5' : '3'), 10) || (small ? 5 : 3), small ? 5 : 3, small ? 10 : 8);
      return Math.ceil(total / 2);
    }
    if (kind === 'baby-breath') {
      return String(item?.mode || '').toLowerCase() === 'sparsa' ? 12 : 7;
    }
    if (kind === 'fresh-baby-breath') {
      return String(item?.mode || '').toLowerCase() === 'sparsa' ? 12 : 7;
    }
    return PROFILES[kind]?.count || 0;
  }

  function roseSize(item) {
    return String(item?.roseSize || '').trim().toLowerCase() === 'piccola' ? 'piccola' : 'media';
  }

  function anchorPlan(kind, count, item) {
    if (kind === 'roses') {
      if (roseSize(item) === 'piccola') {
        return (SIDE_SMALL_ROSE_LAYOUTS[count] || SIDE_SMALL_ROSE_LAYOUTS[3]).map((anchor) => ({ ...anchor }));
      }
      return (SIDE_FLOWER_LAYOUTS[count] || SIDE_FLOWER_LAYOUTS[3]).map((anchor) => ({ ...anchor }));
    }

    if (kind === 'gardenia') {
      return SIDE_GARDENIA_LAYOUT.slice(0, count).map((anchor) => ({ ...anchor }));
    }

    if (kind === 'sunflower') {
      const anchors = count === 1 ? [{ x: 69, y: 71, scale: 1, rotate: -7, depth: 'mid' }] : SIDE_GARDENIA_LAYOUT;
      return anchors.slice(0, count).map((anchor) => ({ ...anchor }));
    }

    if (kind === 'hydrangea') {
      return SIDE_HYDRANGEA_LAYOUT.slice(0, count).map((anchor) => ({ ...anchor }));
    }

    if (kind === 'baby-breath' || kind === 'fresh-baby-breath') {
      const anchors = String(item?.mode || '').toLowerCase() === 'sparsa'
        ? SIDE_BABY_SPARSE_LAYOUT
        : SIDE_BABY_CLUSTER_LAYOUT;
      return anchors.slice(0, count).map((anchor) => ({ ...anchor }));
    }

    if (kind === 'berries' || kind === 'hypericum') {
      return SIDE_LAGURUS_LAYOUT.slice(0, count).map((anchor) => ({ ...anchor }));
    }
    if (kind === 'lagurus') return SIDE_LAGURUS_LAYOUT.slice(0, count).map((anchor) => ({ ...anchor }));

    if (count >= 12) {
      const anchors = kind === 'berries' ? WOVEN_12_ANCHORS : SPARSE_12_ANCHORS;
      return anchors.slice(0, count).map((anchor) => ({ ...anchor }));
    }

    if (count >= 10) {
      const anchors = kind === 'hypericum' ? GENERIC_10_ALT_ANCHORS : GENERIC_10_ANCHORS;
      return anchors.slice(0, count).map((anchor) => ({ ...anchor }));
    }

    const rails = [MID_ANCHORS, NEAR_ANCHORS];
    return Array.from({ length: count }, (_value, index) => {
      const railIndex = index % rails.length;
      const rail = rails[railIndex];
      const rowIndex = Math.round((index / Math.max(1, count - 1)) * (rail.length - 1));
      return { ...rail[rowIndex], depth: ['mid', 'near'][railIndex] };
    });
  }

  function pieceFilter(kind, item) {
    const colorKey = String(item?.colorKey || '').toLowerCase();
    if (kind === 'roses' && NEW_ROSE_FILTERS[colorKey]) return NEW_ROSE_FILTERS[colorKey];
    if (kind === 'roses' && safeUrl(item?.imageUrl) && colorKey !== 'rosso') return 'opacity(1)';
    if (kind === 'baby-breath') {
      if (colorKey === 'rosa' || colorKey === 'viola' || colorKey === 'rosso') return 'opacity(1)';
      const babyFilters = {
        bianco: 'saturate(.96) brightness(.99) contrast(1.01)',
        rosa: 'sepia(.18) saturate(1.8) hue-rotate(292deg) brightness(1.02) contrast(1.01)',
        viola: 'sepia(.3) saturate(2.4) hue-rotate(225deg) brightness(.88) contrast(1.05)',
        rosso: 'sepia(.65) saturate(5) hue-rotate(320deg) brightness(.68) contrast(1.15)',
      };
      return babyFilters[colorKey] || babyFilters.bianco;
    }
    if (kind === 'fresh-baby-breath') return 'grayscale(.06) saturate(.78) brightness(1.18) contrast(1.12) opacity(1)';
    if (kind === 'berries') return 'saturate(.98) brightness(.98) contrast(1.01)';
    if (kind === 'gardenia' && (colorKey === 'bianco' || colorKey === 'bianca' || colorKey === 'bianco-optical')) {
      return MATERIAL_FILTERS.gardenia[colorKey] || MATERIAL_FILTERS.gardenia.bianco;
    }
    if (kind === 'hypericum' && colorKey === 'bianco-avorio') {
      return 'saturate(.88) brightness(.99) contrast(1.02)';
    }
    if (kind === 'hypericum' && colorKey === 'rosa-confetto') {
      return 'grayscale(.28) sepia(.48) saturate(1.5) hue-rotate(322deg) brightness(1.28) contrast(.88)';
    }
    if (MATERIAL_FILTERS[kind]?.[colorKey]) return MATERIAL_FILTERS[kind][colorKey];
    return FILTERS[colorKey] || 'opacity(1)';
  }

  function makeSunflower(anchor, bow = false) {
    const flower = document.createElement('img');
    flower.className = `cl-flower-sunflower ${bow ? 'clside__bow-sunflower' : 'clside__sunflower'}`;
    flower.setAttribute('aria-hidden', 'true');
    flower.alt = '';
    flower.width = 600;
    flower.height = 600;
    flower.loading = 'eager';
    flower.decoding = 'async';
    flower.style.left = `${anchor.x}%`;
    flower.style.top = `${anchor.y}%`;
    flower.style.width = 'var(--cl-sunflower-size, 0px)';
    flower.style.height = 'var(--cl-sunflower-size, 0px)';
    // Perspective anchors still determine placement, never apparent head size.
    flower.style.transform = 'translate(-50%, -50%)';
    return flower;
  }

  function makePiece(kind, item, anchor, index, profile, texture) {
    const image = document.createElement(kind === 'lagurus' ? 'span' : 'img');
    const colorKey = String(item?.colorKey || '').toLowerCase();
    const isBabyBreath = kind === 'baby-breath' || kind === 'fresh-baby-breath';
    const sharesLagurusGrid = kind === 'lagurus' || kind === 'berries' || kind === 'hypericum';
    const geometryKind = sharesLagurusGrid ? 'lagurus' : kind;
    const geometryProfile = sharesLagurusGrid ? PROFILES.lagurus : profile;
    const materialSignature = isBabyBreath
      ? `baby-breath|shared|${item?.mode || ''}`
      : sharesLagurusGrid
        ? 'lagurus|shared-grid'
      : `${kind}|${item?.colorKey || ''}|${item?.mode || ''}|${texture}`;
    const materialHash = hashString(materialSignature);
    const phase = ((index * 37 + materialHash) % 9) - 4;
    const isRose = kind === 'roses';
    const xJitter = anchor.depth === 'near'
      ? phase * (isBabyBreath ? 0.28 : isRose ? 0.12 : 0.48)
      : phase * (isBabyBreath ? 0.22 : isRose ? 0.10 : 0.34);
    const yJitter = (((index * 19 + (materialHash % 97)) % 7) - 3) * (isBabyBreath ? 0.16 : 0.22);
    const scaleJitter = 1 + ((((index * 13 + (materialHash % 71)) % 7) - 3) * 0.015);
    const shouldMirror = !sharesLagurusGrid
      && /baby-breath|fresh-baby-breath|hypericum|berries|hydrangea/.test(kind)
      && index % 2 === 1;
    const volumeProfile = SIDE_VOLUME_PROFILES[geometryKind] || { spread: 1, scale: 0.007, bias: { far: 0, mid: 0, near: 0 } };
    const volumeCurve = SIDE_VOLUME_CURVES[anchor.depth] || SIDE_VOLUME_CURVES.mid;
    const volumePhase = (materialHash + index * 5 + Math.round(anchor.x)) % volumeCurve.length;
    const volumeStrength = typeof anchor.volume === 'number' ? anchor.volume : 0.35;
    const volumeOffset = ((volumeCurve[volumePhase] * volumeProfile.spread) + (volumeProfile.bias[anchor.depth] || 0)) * volumeStrength;
    const babyMode = String(item?.mode || '').toLowerCase();
    const baseDisplayWidth = isBabyBreath
      ? (babyMode === 'sparsa' ? profile.sparseWidth : profile.clusterWidth)
      : profile.width;
    const materialScale = isRose && roseSize(item) === 'piccola'
      ? SMALL_ROSE_SCALE
      : kind === 'berries' && colorKey === 'oro'
        ? 1.22
      : kind === 'berries' && colorKey === 'rosso'
        ? .62
      : kind === 'fresh-baby-breath'
        ? (babyMode === 'sparsa' ? .90 : .78)
      : isBabyBreath
        ? (babyMode === 'sparsa' ? .81 : .68)
        : 1;
    const displayWidth = baseDisplayWidth * materialScale;
    const geometryWidth = sharesLagurusGrid
      ? PROFILES.lagurus.width
      : isBabyBreath
        ? (babyMode === 'sparsa'
          ? PROFILES['baby-breath'].sparseWidth * .62
          : PROFILES['baby-breath'].clusterWidth * .68)
        : displayWidth;
    const naturalX = clamp(anchor.x + geometryProfile.offsetX + xJitter, 4, 97);
    const preliminaryArcY = visibleFrontArcY(naturalX);
    const footprintScale = anchor.scale * scaleJitter;
    const footprintRatios = {
      roses: .5,
      gardenia: .5,
      'baby-breath': .28,
      'fresh-baby-breath': .28,
      lagurus: .42,
      hydrangea: .4,
      berries: .38,
      hypericum: .38,
    };
    const footprintRatio = footprintRatios[geometryKind] || .46;
    const halfFootprint = geometryWidth * footprintScale * footprintRatio;
    const bowSafePosition = keepBowClear(naturalX, preliminaryArcY, index, halfFootprint, halfFootprint * 0.82);
    // Keep a real visual gutter around the photographed wreath. Rotated,
    // directional sprigs have corners that extend beyond their nominal width;
    // the extra allowance prevents hydrangea, Lagurus and baby's-breath from
    // merely touching the crop even when their boxes technically fit.
    const safeInset = Math.max(5.2, (geometryWidth * footprintScale * .5) + 2.2);
    const rightInset = safeInset;
    const projectedX = clamp(bowSafePosition.x, safeInset, 100 - rightInset);
    const frontArcY = visibleFrontArcY(projectedX);
    const proposedY = anchor.y + geometryProfile.offsetY + yJitter + volumeOffset;
    const crownBackReach = isBabyBreath
      ? clamp(8 - (geometryWidth * 0.3), 2.5, 4.8)
      : (MATERIAL_BACK_REACH[geometryKind] || 6);
    const frontReach = anchor.depth === 'near' ? 9.5 : 7;
    const rawProjectedY = isRose && roseSize(item) === 'piccola'
      ? clamp(frontArcY + (anchor.lift || 0) + (yJitter * .35) + (volumeOffset * .22), frontArcY - 3, frontArcY + 5.5)
      : isRose
        ? clamp(frontArcY + 1.8 + (anchor.lift || 0) + (yJitter * 0.35) + (volumeOffset * 0.22), frontArcY, frontArcY + 3.2)
      : clamp(proposedY, frontArcY - crownBackReach, Math.min(frontArcY + frontReach, 91));
    const verticalFootprintRatio = anchor.depth === 'near' ? 0.58 : 0.82;
    const verticalInset = Math.max(anchor.depth === 'near' ? 4.8 : 5.5, halfFootprint * verticalFootprintRatio);
    const projectedY = clamp(rawProjectedY, 47 + (verticalInset * 0.15), 94 - verticalInset);
    const side = clamp((projectedX - 50) / 46, -1, 1);
    const edge = Math.abs(side);
    const scaleX = (1 - edge * geometryProfile.edgeX) * (shouldMirror ? -1 : 1);
    const volumeScale = clamp(1 + (volumeOffset * volumeProfile.scale), 0.94, 1.07);
    const depthY = anchor.depth === 'far'
      ? geometryProfile.farY
      : anchor.depth === 'mid'
        ? (geometryProfile.midY ?? (geometryProfile.farY + geometryProfile.nearY) / 2)
        : geometryProfile.nearY;
    const scaleY = depthY * (1 - edge * 0.035);
    const skew = (-side * geometryProfile.skew) + phase * 0.55;
    const naturalRotation = kind === 'hypericum'
      ? -135 + naturalMaterialRotation('lagurus', projectedX, projectedY, anchor.rotate, phase)
      : kind === 'fresh-baby-breath'
        ? (shouldMirror ? -26 : -154) + naturalMaterialRotation('lagurus', projectedX, projectedY, anchor.rotate, phase)
      : naturalMaterialRotation(geometryKind, projectedX, projectedY, anchor.rotate, phase);

    if (kind === 'hypericum') image.dataset.colorKey = colorKey;
    if (isRose) image.dataset.roseSize = roseSize(item);

    const berryColorClass = kind === 'berries'
      ? ` clside__piece--berries-${colorKey === 'oro' ? 'gold' : 'red'}`
      : '';
    const levelClass = anchor.level ? ` clside__piece--level-${anchor.level}` : '';
    image.className = `clside__piece clside__piece--${profile.className} clside__piece--${anchor.depth}${levelClass}${berryColorClass}`;
    if (kind === 'lagurus') {
      image.style.backgroundImage = `url("${texture}")`;
      image.style.setProperty('--clside-lagurus-texture', `url("${texture}")`);
      image.dataset.colorKey = colorKey;
    } else {
      image.src = texture;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
    }
    image.setAttribute('aria-hidden', 'true');
    image.style.setProperty('--clside-x', `${projectedX}%`);
    image.style.setProperty('--clside-y', `${projectedY}%`);
    image.style.setProperty('--clside-width', `${displayWidth}%`);
    if (kind === 'gardenia' && /^(?:bianco|bianca|bianco-optical)$/.test(colorKey)
      && /(?:^|\/)cl-insert-gardenia-white-v1\.png(?:[?#]|$)/.test(texture)) {
      image.dataset.clsideGardeniaNormalized = 'white-v1';
    }
    image.style.setProperty('--clside-scale', String(anchor.scale * scaleJitter * volumeScale));
    image.style.setProperty('--clside-scale-x', String(scaleX));
    image.style.setProperty('--clside-scale-y', String(scaleY));
    image.style.setProperty('--clside-skew', `${skew}deg`);
    image.style.setProperty('--clside-rotate', `${naturalRotation}deg`);
    image.style.setProperty('--clside-filter', pieceFilter(kind, item));
    image.style.setProperty('--clside-blend', 'normal');
    image.style.zIndex = String(Math.round(projectedY * 20) + (MATERIAL_Z[kind] || 0));
    if (kind !== 'lagurus') image.addEventListener('error', () => { image.hidden = true; }, { once: true });
    return image;
  }

  class SideView {
    constructor(root) {
      this.root = root;
      this.assets = parseAssets(root);
      this.panel = root.querySelector('[data-clside-panel]');
      this.scene = root.querySelector('[data-clside-scene]');
      this.base = root.querySelector('[data-clside-base]');
      this.farLayer = root.querySelector('[data-clside-far]');
      this.midLayer = root.querySelector('[data-clside-mid]');
      this.nearLayer = root.querySelector('[data-clside-near]');
      this.bowRosesLayer = root.querySelector('[data-clside-bow-roses]');
      this.bow = root.querySelector('[data-clside-bow]');
      this.tails = root.querySelector('[data-clside-tails]');
      this.textLeft = root.querySelector('[data-clside-text-left]');
      this.textRight = root.querySelector('[data-clside-text-right]');
      this.status = root.querySelector('[data-clside-status]');
      this.tabs = [...root.querySelectorAll('[data-clside-view]')];
      this.topTab = root.querySelector('[data-clside-view="top"]');
      this.sideTab = root.querySelector('[data-clside-view="side"]');
      this.host = root.closest('cl-configurator');
      this.stateHub = this.findStateHub();
      this.topStage = this.findTopStage();
      this.mode = 'top';
      this.currentState = null;
      this.decorationSignature = '';
      this.positionDecorations = null;

      this.onRootClick = (event) => this.handleClick(event);
      this.onRootKeydown = (event) => this.handleKeydown(event);
      this.onStateUpdate = (event) => this.update(event.detail?.state);
      this.onBaseError = () => this.failGracefully();
      this.onBaseLoad = () => this.root.classList.add('clside--base-ready');

      this.root.addEventListener('click', this.onRootClick);
      this.root.addEventListener('keydown', this.onRootKeydown);
      this.stateHub.addEventListener('cl3d:update', this.onStateUpdate);
      this.base?.addEventListener('error', this.onBaseError, { once: true });
      this.base?.addEventListener('load', this.onBaseLoad, { once: true });
      if (this.base?.getAttribute('src') && this.base.complete) {
        if (this.base.naturalWidth > 0) this.onBaseLoad();
        else this.failGracefully();
      }
      this.prepareTabs();
      this.readInitialState();
    }

    ensureBase() {
      if (!this.base) return;
      const source = safeUrl(this.base.getAttribute('src')) || safeUrl(this.base.dataset.clsideSrc);
      if (!source) {
        this.failGracefully();
        return;
      }
      this.scene?.style.setProperty('--clside-base-image', `url("${source}")`);
      if (this.base.getAttribute('src')) return;
      this.base.src = source;
    }

    findStateHub() {
      if (typeof this.root.cl3dGetState === 'function') return this.root;
      const candidate = this.host?.querySelector('[data-cl3d-root]');
      return candidate || this.root;
    }

    findTopStage() {
      const selector = this.root.dataset.clsideTwoDSelector;
      if (selector) {
        try {
          const scoped = this.host?.querySelector(selector) || document.querySelector(selector);
          if (scoped) return scoped;
        } catch (_error) {
          // Keep the structural fallback below.
        }
      }
      return this.root.closest('.clc__preview-card')?.querySelector('[data-clc-stage]') || this.host?.querySelector('[data-clc-stage]');
    }

    prepareTabs() {
      if (this.topStage && this.topTab) {
        this.topStage.setAttribute('role', 'tabpanel');
        this.topStage.setAttribute('aria-labelledby', this.topTab.id);
      }
      this.switchView('top', false);
    }

    readInitialState() {
      const getter = typeof this.root.cl3dGetState === 'function'
        ? this.root.cl3dGetState.bind(this.root)
        : typeof this.stateHub.cl3dGetState === 'function'
          ? this.stateHub.cl3dGetState.bind(this.stateHub)
          : null;
      if (!getter) return;
      try {
        this.update(getter());
      } catch (_error) {
        // State will arrive through cl3d:update after the configurator initializes.
      }
    }

    handleClick(event) {
      const tab = event.target.closest('[data-clside-view]');
      if (!tab || !this.root.contains(tab) || tab.disabled) return;
      this.switchView(tab.dataset.clsideView, true);
    }

    handleKeydown(event) {
      const tab = event.target.closest('[data-clside-view]');
      if (tab) {
        const index = this.tabs.indexOf(tab);
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const target = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
          target?.focus();
          if (!target?.disabled) this.switchView(target.dataset.clsideView, true);
          return;
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          const target = event.key === 'Home' ? this.tabs[0] : this.tabs[this.tabs.length - 1];
          target?.focus();
          if (!target?.disabled) this.switchView(target.dataset.clsideView, true);
          return;
        }
      }
      if (event.key === 'Escape' && this.mode === 'side') {
        event.preventDefault();
        this.switchView('top', true);
        this.topTab?.focus();
      }
    }

    switchView(mode, announce) {
      const nextMode = mode === 'side' && !this.sideTab?.disabled ? 'side' : 'top';
      this.mode = nextMode;
      const sideActive = nextMode === 'side';

      if (this.topStage) this.topStage.hidden = sideActive;
      if (this.panel) this.panel.hidden = !sideActive;
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.clsideView === nextMode;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });

      if (sideActive) {
        this.ensureBase();
        if (this.mode === 'side' && this.currentState) this.render(this.currentState);
      }
      if (announce && this.status) {
        this.status.textContent = sideActive ? 'Vista laterale attivata.' : 'Vista dall’alto attivata.';
      }
    }

    update(state) {
      if (!state || typeof state !== 'object') return;
      this.currentState = state;
      if (this.mode === 'side') this.render(state);
    }

    render(state) {
      if (!this.scene || !this.farLayer || !this.midLayer || !this.nearLayer) return;
      const decorationItems = itemList(state).filter((item) => !['bow-roses', 'bow-sunflower'].includes(normalizeKind(item)));
      const nextSignature = JSON.stringify(decorationItems.map((item) => ({
        type: normalizeKind(item),
        imageUrl: item.imageUrl || '',
        colorKey: item.colorKey || '',
        quantity: item.quantity || 1,
        mode: item.mode || '',
        roseSize: normalizeKind(item) === 'roses' ? roseSize(item) : '',
        roseColors: item.roseColors || null,
      })));

      if (nextSignature !== this.decorationSignature) {
        const farFragment = document.createDocumentFragment();
        const midFragment = document.createDocumentFragment();
        const nearFragment = document.createDocumentFragment();
        const positionedEntries = [];
        decorationItems.forEach((item) => {
          const kind = normalizeKind(item);
          const profile = PROFILES[kind];
          const texture = textureFor(kind, item, this.assets);
          if (!profile || (!texture && kind !== 'sunflower')) return;
          const count = profileCount(kind, item);
          anchorPlan(kind, count, item).forEach((anchor, index) => {
            const piece = kind === 'sunflower' ? makeSunflower(anchor) : makePiece(kind, item, anchor, index, profile, texture);
            const roseColor = kind === 'roses' && Array.isArray(item.roseColors) ? item.roseColors[index] : null;
            if (roseColor) {
              const material = { ...item, ...roseColor, imageUrl: roseColor.imageUrl || roseColor.image || '' };
              const image = textureFor(kind, material, this.assets);
              if (image) piece.src = image;
              piece.style.filter = pieceFilter(kind, material);
              piece.dataset.colorKey = material.colorKey;
            }
            if (kind === 'sunflower') this.host?.clSunflowerPhotoPreview?.watch(piece);
            positionedEntries.push({ kind, item, piece, index });
            const fragment = anchor.depth === 'far' ? farFragment : anchor.depth === 'mid' ? midFragment : nearFragment;
            fragment.append(piece);
          });
        });
        this.farLayer.replaceChildren(farFragment);
        this.midLayer.replaceChildren(midFragment);
        this.nearLayer.replaceChildren(nearFragment);
        this.decorationSignature = nextSignature;
        const positionBabies = () => {
          if (this.positionDecorations === positionBabies && this.decorationSignature === nextSignature) placeBabyFront(this.scene, positionedEntries);
        };
        this.positionDecorations = positionBabies;
        // One finite re-evaluation as each image becomes measurable. No RAF
        // loop, no GPU renderer, and stale detached compositions are ignored.
        positionedEntries.forEach(({ piece }) => {
          if (piece.tagName === 'IMG' && !piece.complete) piece.addEventListener('load', positionBabies, { once: true });
        });
      }
      // A hidden panel may have completed loading without measurable rectangles.
      // Reuse its current composition when it becomes visible; do not change layout.
      this.positionDecorations?.();
      this.renderRibbon(state);
      this.renderBowRoses(state);
      this.updateDescription(state);
    }

    renderRibbon(state) {
      const color = SAFE_COLOR.test(state.ribbonColor || '') ? state.ribbonColor : '#b31f2b';
      const ink = SAFE_COLOR.test(state.letteringHex || '') ? state.letteringHex : '#fffaf0';
      const shape = state.bowShape === 'coccarda' ? 'coccarda' : 'farfalla';
      const width = state.ribbonWidth === 'stretto' ? 'stretto' : 'largo';
      const bands = clamp(Number.parseInt(state.bands || '2', 10) || 2, 2, 6);
      const bowAsset = shape === 'coccarda' ? this.assets.bowCoccarda : this.assets.bowFarfalla;
      this.scene.style.setProperty('--clside-ribbon', color);
      this.scene.style.setProperty('--clside-lettering', ink);
      if (bowAsset) this.bow.style.setProperty('--clside-bow-image', `url("${bowAsset}")`);
      if (this.assets.ribbonTail) this.scene.style.setProperty('--clside-tail-image', `url("${this.assets.ribbonTail}")`);
      this.bow.dataset.shape = shape;
      this.bow.dataset.width = width;
      this.tails.dataset.bands = String(bands);
      [...this.tails.children].forEach((tail, index) => { tail.hidden = index >= bands; });
      if (this.textLeft) this.textLeft.textContent = String(state.textLeft || '').slice(0, 28);
      if (this.textRight) this.textRight.textContent = String(state.textRight || '').slice(0, 28);
    }

    renderBowRoses(state) {
      if (!this.bowRosesLayer) return;
      const sunflower = itemList(state).find((candidate) => normalizeKind(candidate) === 'bow-sunflower');
      if (sunflower) {
        const flower = makeSunflower({ x: 20.5, y: 64.5 }, true);
        this.host?.clSunflowerPhotoPreview?.watch(flower);
        this.bowRosesLayer.replaceChildren(flower);
        return;
      }
      const item = itemList(state).find((candidate) => normalizeKind(candidate) === 'bow-roses');
      if (!item) {
        this.bowRosesLayer.replaceChildren();
        return;
      }
      const texture = safeUrl(item.imageUrl) || this.assets.singleRose || this.assets.rose;
      if (!texture) return;
      const count = clamp(Number.parseInt(item.quantity || '1', 10) || 1, 1, 3);
      const fragment = document.createDocumentFragment();
      const positions = [
        { x: 17.3, y: 64.8, rotate: -12 },
        { x: 20.5, y: 63.9, rotate: 2 },
        { x: 23.6, y: 64.9, rotate: 13 },
      ];
      positions.slice(0, count).forEach((position, index) => {
        const image = document.createElement('img');
        image.className = 'clside__bow-rose';
        const entry = Array.isArray(item.roseColors) ? item.roseColors[index] : null;
        image.src = safeUrl(entry?.imageUrl || entry?.image) || texture;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.setAttribute('aria-hidden', 'true');
        image.style.setProperty('--clside-x', `${position.x}%`);
        image.style.setProperty('--clside-y', `${position.y}%`);
        image.style.setProperty('--clside-rotate', `${position.rotate + index * 2}deg`);
        image.style.width = item.flowerSize === 'media' ? '8.2%' : '6.5%';
        image.style.filter = NEW_ROSE_FILTERS[String(entry?.colorKey || item.colorKey || '').toLowerCase()] || '';
        if (entry) image.dataset.colorKey = entry.colorKey;
        fragment.append(image);
      });
      this.bowRosesLayer.replaceChildren(fragment);
    }

    updateDescription(state) {
      const decorations = itemList(state).map((item) => item.label).filter(Boolean);
      const bow = state.bowShape === 'coccarda' ? 'fiocco coccarda' : 'fiocco farfalla';
      const bands = Number.parseInt(state.bands || '2', 10) || 2;
      const parts = [`Corona d’alloro in vista laterale, decorazioni sul semicerchio visibile`, bow, `${bands} bande`];
      if (state.ribbonColorName) parts.push(`nastro ${state.ribbonColorName}`);
      if (decorations.length) parts.push(`decorazioni: ${decorations.join(', ')}`);
      this.scene?.setAttribute('aria-label', `${parts.join('; ')}.`);
    }

    failGracefully() {
      const wasSideActive = this.mode === 'side';
      this.root.classList.add('clside--failed');
      if (this.sideTab) {
        this.sideTab.disabled = true;
        this.sideTab.setAttribute('aria-disabled', 'true');
      }
      // Let an optional three-view controller own the selected panel. A late
      // photograph error must not reveal Dall'alto over an active 3D view.
      const delegated = !this.root.dispatchEvent(new CustomEvent('clside:unavailable', { cancelable: true }));
      if (!delegated) {
        this.switchView('top', false);
        if (wasSideActive) this.topTab?.focus();
      }
      if (this.status) this.status.textContent = 'Vista laterale temporaneamente non disponibile.';
    }

    destroy() {
      this.positionDecorations = null;
      this.switchView('top', false);
      this.root.removeEventListener('click', this.onRootClick);
      this.root.removeEventListener('keydown', this.onRootKeydown);
      this.stateHub.removeEventListener('cl3d:update', this.onStateUpdate);
      this.base?.removeEventListener('error', this.onBaseError);
      this.base?.removeEventListener('load', this.onBaseLoad);
      this.root.clsideInstance = null;
      delete this.root.dataset.clsideReady;
    }
  }

  function mount(scope = document) {
    const hosts = [];
    if (scope.matches?.('cl-configurator[data-sunflower-photo-url]')) hosts.push(scope);
    scope.querySelectorAll?.('cl-configurator[data-sunflower-photo-url]').forEach((host) => hosts.push(host));
    hosts.forEach((host) => {
      if (!host.clSunflowerPhotoPreview) host.clSunflowerPhotoPreview = createSunflowerPhotoPreview(host);
    });
    const roots = [];
    if (scope.matches?.(ROOT_SELECTOR)) roots.push(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));
    roots.forEach((root) => {
      if (root.dataset.clsideReady === 'true') return;
      root.dataset.clsideReady = 'true';
      root.clsideInstance = new SideView(root);
    });
  }

  function unmount(scope) {
    if (!scope) return;
    const roots = [];
    if (scope.matches?.(ROOT_SELECTOR)) roots.push(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));
    roots.forEach((root) => root.clsideInstance?.destroy());
    const hosts = [];
    if (scope.matches?.('cl-configurator[data-sunflower-photo-url]')) hosts.push(scope);
    scope.querySelectorAll?.('cl-configurator[data-sunflower-photo-url]').forEach((host) => hosts.push(host));
    hosts.forEach((host) => host.clSunflowerPhotoPreview?.destroy());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
})();
